import { runNamedCallback } from '../helpers.js';
import { postRoleSwitch } from '../shared/auth-navigate.js';
import { createChromeBlurBackdrop } from '../shared/chrome-blur-backdrop.js';
import { getMemberNavAction, runMemberNavAction } from '../members/member-nav-registry.js';

const ACCOUNT_MENU_BACKDROP_ID = 'topbarAccountMenuBackdrop';

let accountMenuBackdrop = null;

function syncAccountMenuBackdrop() {
    if (!accountMenuBackdrop) {
        throw new Error('topbar account menu backdrop is not initialized');
    }
    accountMenuBackdrop.setOpen(document.querySelector('.topbar-account-menu.show') !== null);
}

function setTopbarDropdownOpen($dropdown, open) {
    const $menu = $dropdown.find('.dropdown-menu');
    const $toggle = $dropdown.find('.dropdown-toggle');
    if (open) {
        $dropdown.addClass('show');
        $menu.addClass('show');
        $toggle.attr('aria-expanded', 'true');
    } else {
        $dropdown.removeClass('show');
        $menu.removeClass('show');
        $toggle.attr('aria-expanded', 'false');
    }
    syncAccountMenuBackdrop();
}

function closeAllTopbarAccountMenus() {
    $('.topbar-account-menu').each(function () {
        setTopbarDropdownOpen($(this), false);
    });
}

function runLogoutAction($root) {
    const modalTarget = String($root.data('logout-modal-target') || '').trim();
    const callbackName = String($root.data('logout-callback') || '').trim();
    if (modalTarget !== '' && typeof $ === 'function' && $(modalTarget).length) {
        $(modalTarget).modal('show');
        return;
    }
    if (callbackName === '') {
        return;
    }
    getMemberNavAction(callbackName)();
}

function runTopbarAction(actionName) {
    switch (actionName) {
        case 'member-login':
            runMemberNavAction('MemberLoginPage');
            break;
        case 'member-register':
            runMemberNavAction('MemberRegisterPage');
            break;
    }
}

export function initTopbarAccountMenus() {
    const $roots = $('.topbar-account-menu');
    if (!$roots.length) {
        return;
    }

    const topBar = document.querySelector('.topBar, .topMemberBar');
    if (!topBar || !(topBar.parentElement instanceof HTMLElement)) {
        throw new Error('topbar account menu backdrop mount is missing');
    }

    accountMenuBackdrop = createChromeBlurBackdrop({
        id: ACCOUNT_MENU_BACKDROP_ID,
        label: 'Close account menu',
        onDismiss: closeAllTopbarAccountMenus,
        mount: topBar.parentElement,
    });

    $roots.each(function () {
        const $root = $(this);
        const $toggle = $root.find('.dropdown-toggle');
        const $menu = $root.find('.dropdown-menu');

        $toggle.off('click.topbarAccountMenu').on('click.topbarAccountMenu', function (event) {
            event.preventDefault();
            event.stopPropagation();
            const isOpen = $root.hasClass('show');
            closeAllTopbarAccountMenus();
            setTopbarDropdownOpen($root, !isOpen);
        });

        $menu.off('click.topbarAccountMenu').on('click.topbarAccountMenu', function (event) {
            event.stopPropagation();
        });

        $menu.find('[data-logout-trigger]').off('click.topbarAccountMenu').on('click.topbarAccountMenu', function (event) {
            event.preventDefault();
            setTopbarDropdownOpen($root, false);
            runLogoutAction($root);
        });

        $menu.find('.dropdown-item').off('click.topbarAccountMenuClose').on('click.topbarAccountMenuClose', function () {
            setTopbarDropdownOpen($root, false);
        });

        $menu.find('.dropdown-item[data-topbar-action]').off('click.topbarAccountMenuAction').on('click.topbarAccountMenuAction', function (event) {
            event.preventDefault();
            runTopbarAction(String($(this).data('topbar-action') || ''));
        });

        $menu.find('.dropdown-item[data-onclick]').off('click.topbarAccountMenuOnclick').on('click.topbarAccountMenuOnclick', function (event) {
            event.preventDefault();
            runNamedCallback($(this).data('onclick'), event);
        });

        $menu.find('[data-role-switch-url]').off('click.topbarAccountMenuRoleSwitch').on('click.topbarAccountMenuRoleSwitch', function (event) {
            event.preventDefault();
            const $item = $(this);
            postRoleSwitch(String($item.data('role-switch-url') || ''), String($item.data('csrf-token') || ''));
        });
    });

    $(document).off('click.topbarAccountMenu').on('click.topbarAccountMenu', function (event) {
        if ($(event.target).closest('.topbar-account-menu').length) {
            return;
        }
        if (event.target === accountMenuBackdrop.element) {
            return;
        }
        closeAllTopbarAccountMenus();
    });

    $(document).off('keydown.topbarAccountMenu').on('keydown.topbarAccountMenu', function (event) {
        if (event.key !== 'Escape') {
            return;
        }
        closeAllTopbarAccountMenus();
    });

    syncAccountMenuBackdrop();
}
